import React from 'react';

export const PainelAdminVendedorModal = ({
  isOpen,
  isEdit,
  vendedorForm,
  setVendedorForm,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) {
    return null;
  }

  const modePrefix = isEdit ? 'edit' : 'add';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid={`painel-admin-${modePrefix}-vendedor-modal-overlay`}>
      <div className="bg-white rounded-2xl w-full max-w-md p-6" data-testid={`painel-admin-${modePrefix}-vendedor-modal`}>
        <h3 className="text-xl font-bold mb-4" data-testid={`painel-admin-${modePrefix}-vendedor-title`}>
          {isEdit ? 'Editar Vendedor' : 'Novo Vendedor'}
        </h3>
        <form onSubmit={onSubmit} className="space-y-3" data-testid={`painel-admin-${modePrefix}-vendedor-form`}>
          <input
            type="text"
            placeholder="Nome *"
            value={vendedorForm.nome}
            onChange={(event) => setVendedorForm({ ...vendedorForm, nome: event.target.value })}
            required
            className="w-full px-4 py-2 border rounded-lg"
            data-testid={`painel-admin-${modePrefix}-vendedor-name-input`}
          />
          <input
            type="tel"
            placeholder="Telefone"
            value={vendedorForm.telefone}
            onChange={(event) => setVendedorForm({ ...vendedorForm, telefone: event.target.value })}
            className="w-full px-4 py-2 border rounded-lg"
            data-testid={`painel-admin-${modePrefix}-vendedor-telefone-input`}
          />
          <input
            type="tel"
            placeholder="WhatsApp"
            value={vendedorForm.whatsapp}
            onChange={(event) => setVendedorForm({ ...vendedorForm, whatsapp: event.target.value })}
            className="w-full px-4 py-2 border rounded-lg"
            data-testid={`painel-admin-${modePrefix}-vendedor-whatsapp-input`}
          />
          <input
            type="email"
            placeholder="Email"
            value={vendedorForm.email}
            onChange={(event) => setVendedorForm({ ...vendedorForm, email: event.target.value })}
            className="w-full px-4 py-2 border rounded-lg"
            data-testid={`painel-admin-${modePrefix}-vendedor-email-input`}
          />
          <select
            value={vendedorForm.especialidade}
            onChange={(event) => setVendedorForm({ ...vendedorForm, especialidade: event.target.value })}
            className="w-full px-4 py-2 border rounded-lg"
            data-testid={`painel-admin-${modePrefix}-vendedor-especialidade-select`}
          >
            <option value="todos">Todos os Serviços</option>
            <option value="casas">Casas</option>
            <option value="carros">Carros</option>
            <option value="reformas">Reformas</option>
          </select>
          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 py-2 border rounded-lg" data-testid={`painel-admin-${modePrefix}-vendedor-cancel-button`}>
              Cancelar
            </button>
            <button type="submit" className="flex-1 py-2 bg-blue-600 text-white rounded-lg" data-testid={`painel-admin-${modePrefix}-vendedor-submit-button`}>
              {isEdit ? 'Salvar' : 'Adicionar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
